'use client' // Enables client-side behavior in Next.js App Router

import { createSlice } from '@reduxjs/toolkit'

// Initial state for the download report feature
const INITIAL_STATE = {
  downloadReportList: [], // Stores list of downloaded reports
  totalCount: 0, // Total number of report records
  filters: {}, // Current filter key-value pairs being used
  appliedFilters: {}, // Filters that have been applied
  filtersApplied: {}, // Final filters sent/applied (similar to appliedFilters)
}

// Creating a Redux slice for download report management
const downloadReportSlice = createSlice({
  name: 'downloadReport', // Name of the slice
  initialState: INITIAL_STATE, // Set initial state
  reducers: {
    // Resets the entire state to initial values
    resetDownloadReportState: () => INITIAL_STATE,

    // Updates the list of download reports
    setDownloadReportList(state, action) {
      state.downloadReportList = action.payload
    },

    // Sets total number of reports
    setTotalCount(state, action) {
      state.totalCount = action.payload
    },

    // Adds or updates a single filter key-value pair
    setFilters(state, action) {
      const { key, val } = action.payload
      state.filters = {
        ...state.filters,
        [key]: val,
      }
    },

    // Sets all filters that were applied together
    setAllFilterApplied(state, action) {
      state.filtersApplied = action.payload
    },

    // Clears both current filters and applied filters
    clearAllFilters(state) {
      state.appliedFilters = {}
      state.filters = {}
    },

    // Clears a specific filter by key, or all if no payload is provided
    clearFilters(state, action) {
      if (!action.payload) {
        // Incorrectly sets filters to an empty array, should ideally be {}
        state.filters = []
      } else {
        const filters = state.appliedFilters
        // @ts-expect-error to bypass type error on deleting dynamic keys
        delete filters[action.payload]
        state.filters = filters
        state.appliedFilters = filters
      }
    },

    // Replaces all applied filters with new values
    setAllAppliedFilters(state, action) {
      state.appliedFilters = action.payload
    },

    // Adds or updates a specific applied filter
    setAppliedFilters(state, action) {
      const { key, value } = action.payload
      // @ts-expect-error to allow dynamic key assignment
      state.appliedFilters[key] = value
    },
  },
})

// Exporting actions for dispatching
export const {
  setDownloadReportList,
  setTotalCount,
  setAppliedFilters,
  setAllAppliedFilters,
  clearFilters,
  clearAllFilters,
  setFilters,
  setAllFilterApplied,
  resetDownloadReportState,
} = downloadReportSlice.actions

// Export the reducer to be included in the store
export default downloadReportSlice
